const BRKTST = "8p7ApPZxC_37M06QHVejCQrKsHbcJEerd3jWNkDUWPQ"
const MOCKAO = "0udHxHUaSZI4aIs4hD6rF2jRas4G_XWYnn6JwxXd0II"

export const VERIFIED_TOKENS = [BRKTST, MOCKAO]
